import React, { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import { useParams } from "react-router-dom";
import { useMatterType } from "../../../contexts/MatterTypeContext";
import { getSubdomainFromUrl } from "../../../utils/url";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import LoadingView from "../../../components/LoadingView";
import { Heading, Subheading } from "../../../design/heading";
import { Matter, MatterStatus } from "../../../models/Matter";
import { EventSubtype } from "../../../models/EventSubtype";
import EmptyStateView from "../../../components/EmptyStateView";
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
} from "../../../design/table";

const MatterTypeMatterList: React.FC = () => {
  const { user } = useAuth();
  const { matterTypeId } = useParams<{ matterTypeId: string }>();
  const [matters, setMatters] = useState<Matter[]>([]);

  useEffect(() => {
    if (!user || !matterTypeId) return;
    const tenantId = getSubdomainFromUrl(window.location.href);
    const docRef = query(
      collection(db, "tenants", tenantId, "matters"),
      where("matterTypeId", "==", matterTypeId),
    );
    const unsubscribe = onSnapshot(
      docRef,
      (querySnapshot) => {
        const matters = querySnapshot.docs.map((doc) => ({
          _id: doc.id,
          ...doc.data(),
        })) as Matter[];
        setMatters(matters);
      },
      (error) => {
        console.error("Failed to fetch eventSubtypes:", error.message);
        setMatters([]);
      },
    );
    return () => {
      unsubscribe();
    };
  }, [matterTypeId]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col gap-2">
          <Subheading>Matters</Subheading>
        </div>
        <div className="flex gap-4"></div>
      </div>
      {matters.length === 0 && (
        <EmptyStateView
          title="No Matters"
          message="There are no Matters associated with this Matter Type"
          className="h-full"
        />
      )}
      {matters.length > 0 && (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader>Created At</TableHeader>
              <TableHeader>Updated At</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {matters.map((matter) => (
              <TableRow key={matter._id} href={`/matter/${matter._id}`}>
                <TableCell>{matter.name}</TableCell>
                <TableCell>
                  {matter.createdAt.toLocaleDateString("en-US")}
                </TableCell>
                <TableCell>
                  {matter.updatedAt.toLocaleDateString("en-US")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default MatterTypeMatterList;
